import constants from "./constants"
import { TrackingUtil } from "./tracking"
import {JSErrorTracking} from "./js-error-tracking"
 
export class LinkUtil {

    /**
     * To make a click out on a non-native link (div wrapper) click
     *
     * @param id
     * @param uuid
     * @param link
     * @param direct
     * @param tracking
     * @param pageId
     * @param location
     * @returns {boolean}
     */
     static clickout(id, uuid, link, direct, tracking, pageId, location) {
        
        if (id === ""){
            JSErrorTracking.sendCustomError("Clickout Error - ID is empty");
        }
        
        if ((link === "" || link === undefined)) {
            JSErrorTracking.sendCustomError("Clickout Error - Link is empty");
        }
        
        // construct a timestamp & random number as clickout identifier
        let d = new Date(),
            ts = Math.round((d.getTime() + d.getTimezoneOffset() * 60 * 1000) / 1000),
            rnd = Math.floor(Math.random() * 999999),
            url = constants.REDIRECT_URL + '?source=1&id=' + id + '&go=' + link + '&ts=' + ts + '&rnd=' + rnd + '&productUuid=' + uuid + '&pageId=' + pageId;
            
        if (direct) {
            url += '&direct=true';
        }

        /**
         * To go to the redirect url in a separate browser tab
         */
        this.goToUrlBlank(url);

        /**
         * To track a click out event, if requested
         */
        if (tracking) {
            this.trackClickout(id, uuid, location, ts, rnd);
        }
        
        return false;
    }

    /**
     * To make a request for url redirect tracking in a separate iframe
     *
     * @param id
     * @param uuid
     * @param location
     * @param ts
     * @param rnd
     */
    static trackClickout(id, uuid, location, ts, rnd) {
        /**
         * To initialize timestamp and random value, if not provided
         */
        if (!ts || ts === undefined) {
            let d = new Date();
            ts = Math.round((d.getTime() + d.getTimezoneOffset() * 60 * 1000) / 1000);
        }

        if (!rnd || rnd === undefined) {
            rnd = Math.floor(Math.random() * 999999);
        }

        /**
         * To make a request to the redirect tracking url in a separate iframe
         */
        $('body').append($('<iframe>', {
            src: constants.REDIRECT_TRACKING_URL + '?id=' + id + '&ts=' + ts + '&rnd=' + rnd + '&productUuid=' + uuid,
            width: '0',
            height: '0'
        }).css({
            width: '0px',
            height: '0px'
        }));

        /**
         * To fire a click out event
         */
        TrackingUtil.throwClickout(id, ts, rnd, uuid, location);
    }

    /**
     * Go to url
     *
     * @param url
     */
    static goToUrl(url) {
        if (url) {
            window.location.href = url;
        }
    }

    /**
     * open a given url in a new tab
     * @param url - the url
     */
    static goToUrlBlank(url) {
        if (url) {
            let newWindow = window.open(url, '_blank');
            
            if(newWindow !== undefined && newWindow !== null) {
            	newWindow.focus();
            } else {
            	// fallback for browser blocking the opening in a new tab
            	window.location.href = url;
            }
        }
    }
}
